<div class="fa pointer" [ngClass]="{'fa-square-o': !state, 'fa-check-square-o': state}" (click)="changeState()"></div>